// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3ymiz","footer":"ModalUpdate_footer__ey2CN"};